import React, { FC } from 'react'
import { Layout, Row } from 'antd'
import { HeaderText } from '../common/HeaderText'
const { TwitchEmbed } = require('react-twitch-embed')
const { Header, Content } = Layout

export const Twitch: FC = () => {
    return (
        <Layout>
            <Header>
                <Row justify="space-between">
                    <HeaderText title={"Twitch"} />
                </Row>
            </Header>
            <Content style={{ padding: 24 }}>
                <Row justify="space-between">
                    <TwitchEmbed
                        id="twitch-1"
                        key="twitch-1"
                        channel="ObiWannCoyote"
                        theme="dark"
                        margin="0"
                        height="800px"
                        width="90%"
                        autoplay={false}
                        muted={true}
                    />
                    {/* <TwitchEmbed
                        id="twitch-2"
                        key="twitch-2"
                        channel="1HITBro"
                        theme="dark"
                        height="800px"
                        width="50%"
                        autoplay={false}
                        muted={true}
                    /> */}
                </Row>
            </Content>
        </Layout>
    )
}